import { useSearchParams } from 'react-router-dom'
import { FormSkeleton } from 'src/pages/budget/components'
import {
  useCreateContextGate,
  useContextRequest,
} from 'src/pages/budget/budgetRequests/hooks'
import { RequestPayload } from 'src/pages/budget/budgetRequests/types'
import { RequestWidget } from 'src/pages/budget/budgetRequests/widgets'

export const CreateRequest = () => {
  useCreateContextGate()

  const [searchParams] = useSearchParams()
  const { loading, defaultTeamId } = useContextRequest()

  const currentPeriodId = Number(searchParams.get('currentPeriodId'))

  if (loading) {
    return <FormSkeleton />
  }

  const initialValues: Partial<RequestPayload> = {
    budgetPeriod: currentPeriodId ?? undefined,
    team: defaultTeamId ?? undefined,
  }

  return <RequestWidget initialValues={initialValues} mode="createOwn" />
}
